import React from 'react';

const auxilliary = props => (
    <div className={props.classes}>
        {props.children}
    </div>
);

export default auxilliary;